module.exports = require('browserify-sha3').SHA3Hash



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/keccakjs/browser.js
// module id = sE57
// module chunks = 15